import classNames from 'classnames/bind';
import styles from './Customers.module.scss';
import Image from 'next/image';

let cx = classNames.bind(styles);

/**
 * Customers component that displays a single-line carousel:
 * - ACF-based customer logos (scrolls right to left)
 * 
 * Required GraphQL query fields for customer logos:
 * - customerlogos: Array of customer logo objects
 * - customersheader: String for the section heading (optional)
 * - customerssubheader: String for the section subheading (optional)
 */
export default function Customers({ frontPageData }) {
  // Get ACF customer logos
  const customerLogos = Array.isArray(frontPageData?.customerlogos) 
    ? frontPageData.customerlogos.filter(item => item?.logo?.node?.mediaItemUrl)
    : [];
  
  return (
    <section className={cx('customers')}>
      <>
        <div className={cx('cosmicParticle')}></div>
        <div className={cx('cosmicParticle')}></div>
        <div className={cx('cosmicParticle')}></div>
        <div className={cx('cosmicParticle')}></div>
        <div className={cx('cosmicParticle')}></div>
      </>
      <div className={cx('container')}>
        {/* Header section with ACF fields - only render if they exist */}
        {(frontPageData?.customersheader || frontPageData?.customerssubheader) && (
          <div className={cx('header')}>
            {frontPageData?.customersheader && <h2>{frontPageData.customersheader}</h2>}
            {frontPageData?.customerssubheader && <p className={cx('subheader')}>{frontPageData.customerssubheader}</p>}
          </div>
        )}
        
        {/* Single customer logos carousel */}
        <div className={cx('carouselWrapper')}>
          {/* Customer logos carousel - scrolls right to left */}
          {customerLogos.length > 0 && (
            <div className={cx('logoSlider', 'secondRow')}>
              <div className={cx('logoTrack', 'scrollLeft')}>
                {/* Duplicate logos for seamless loop */}
                {[...customerLogos, ...customerLogos, ...customerLogos].map((item, index) => (
                  <div key={`customer-${index}`} className={cx('customerLogo')}>
                    <Image
                      src={item.logo.node.mediaItemUrl}
                      alt={item.logo.node.altText || 'Customer logo'}
                      width={160}
                      height={80}
                      className={cx('logoImage')}
                      style={{
                        objectFit: 'contain',
                        objectPosition: 'center'
                      }}
                    />
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
} 